import { cn } from "@/lib/cn";
import { Skeleton } from "../Skeleton";
import { RegionCargando } from "./RegionCargando";

export interface CardsGridSkeletonProps {
  tarjetas?: number;
  /** Clases de la rejilla · default 1/2/3 columnas (sm/lg), la galería típica del portal. */
  className?: string;
  /** false cuando ya lo anuncia un contenedor padre. */
  anunciar?: boolean;
  etiqueta?: string;
}

/** Galería de tarjetas en carga (ícono, título y descripción de 2 líneas). */
export function CardsGridSkeleton({ tarjetas = 3, className, anunciar = true, etiqueta }: CardsGridSkeletonProps) {
  const clases = cn("grid gap-3 sm:grid-cols-2 lg:grid-cols-3", className);
  const contenido = Array.from({ length: tarjetas }, (_, i) => (
    <div key={i} className="flex flex-col gap-2 rounded-lg border border-border bg-card p-4" aria-hidden="true">
      <Skeleton height={18} width={18} />
      <Skeleton height={14} width={i % 2 === 0 ? "65%" : "50%"} />
      <Skeleton height={10} width="90%" />
      <Skeleton height={10} width="70%" />
    </div>
  ));
  return anunciar ? (
    <RegionCargando etiqueta={etiqueta} className={clases}>
      {contenido}
    </RegionCargando>
  ) : (
    <div className={clases}>{contenido}</div>
  );
}
